/* ==========================================================================
   PanelPet > CheckboxToggle
   ========================================================================== */

/* Modules */
const CheckboxToggleClient = require('../../../checkbox-toggle/client/js');
const { updateUi } = require('./ui');

/* Init Checkbox Toggle */
function initCheckboxToggle(selector, configuration, instance) {
    const toggle = CheckboxToggleClient(selector, {
        ...configuration,
        onChange: [() => updateUi(instance), checkbox => configuration.onChangeToggle(checkbox, instance)]
    });

    /* Return the checkbox toggle instance */
    return toggle;
}

module.exports = {
    initCheckboxToggle
};
